import { FooterWrapper } from './FooterStyle';

const Footer = () => {
  return (
    <FooterWrapper>
      powered by dev <a href="https://www.facebook.com/muhammedmashhour0">Muhammed Mashhour</a>
    </FooterWrapper>
  )
}

export default Footer